import React from 'react'

import {PriceAlertPromptSheet} from './PriceAlertPromptSheet'
import {usePriceAlertPrompt} from './usePriceAlertPrompt'

import type {ContentHotel, Hotel} from '@findhotel/sapi'

interface Props {
  hotel: Hotel | ContentHotel | undefined
}

/**
 * Proactive "Want to track this price?" prompt (#186392). Eligibility, the 30s
 * trigger and analytics live in `usePriceAlertPrompt` (SSR-safe); the sheet, and the
 * Price Watch action hook, render only once open, so nothing heavy runs on the
 * server or for users who never see the prompt.
 *
 * Mount with `key={hotel.objectID}` so it restarts per hotel (AP→AP is an SPA
 * transition that reuses the page component).
 */
export const PriceAlertPrompt = ({hotel}: Props) => {
  const {isOpen, hide, dismiss} = usePriceAlertPrompt(hotel)

  if (!isOpen) return null

  return (
    <PriceAlertPromptSheet hotel={hotel} onClose={hide} onDismiss={dismiss} />
  )
}
